<nav role="navigation" id="#sidebar" class="navbar-default navbar-static-side">
  <ul class="nav">
    @for (menu of allowedOptions; track menu) {
      @if (!menu.hidden) {
        <li [ngClass]="{ 'active' : isMenuActive(menu) }" class="spacing"
          (mouseover)="showMenuItem(menu.id)">
          @if (menu.url) {
            <a target="_self" class="box-icon-menu float-left {{menu.iconClass}} new-menu-icon"
              [ngClass]="{'fa-background' : menu.faIcon}" (click)="clickMenu(menu)"
              (mouseout)="unshowMenuItemFromIcon($event)">
              @if (menu.faIcon) {
                <em class="fa" [ngClass]="menu.faIcon"></em>
              }
            </a>
          }
          @if (!menu.url && !menu.showSubMenu) {
            <a class="box-icon-menu float-left {{menu.iconClass}}">
              @if (menu.faIcon) {
                <em class="fa" [ngClass]="menu.faIcon"></em>
              }
            </a>
          }
          @if (!menu.showSubMenu && openMenu === menu.id) {
            <a class="area-info first-submenu" (click)="clickMenu(menu)"
              (mouseout)="unshowMenuItem()">
              <span class="menu-title" translate>{{menu.token}}</span>
            </a>
          }
          @for (submenu of menu.subMenuOptions; track submenu; let isFirst = $first) {
            <div>
              @if (submenu.show && openMenu === menu.id) {
                <a class="area-info" [class.first-submenu]="isFirst"
                  (click)="clickMenu(submenu)" (mouseout)="unshowSubMenuItem($event, menu, submenu)">
                  <span class="menu-title" translate>{{submenu.token}}</span>
                </a>
              }
            </div>
          }
        </li>
      }
    }
  </ul>
</nav>

@if (showRenovatingPopup) {
  <bv-bavel-renovating-popoup (closePopup)="onCloseRenovatingPopup($event)"></bv-bavel-renovating-popoup>
}
